import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import postUserOrderDelivered from './postUserOrderDelivered';

export interface IPostUserOrderDeliveredPayload {
  store_order_guid?: string;
  order_guid?: string;
}

const usePostUserOrderDelivered = (handleAfterSuccess?: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostUserOrderDeliveredPayload) => {
      return postUserOrderDelivered(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostUserOrderDelivered;
